/* eslint-disable max-len */
import React from 'react';

export function Playground(props: React.ComponentPropsWithoutRef<'svg'>) {
  const { fill, ...rest } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64" {...rest}>
      <rect width="64" height="64" fill={fill || '#525266'} rx="32"></rect>
      <g clipPath="url(#clip0_2499_183)">
        <path
          fill="url(#paint0_linear_2499_183)"
          d="M26.495 35.261l-12.563-7.348.044 14.738L26.536 50l-.04-14.739z"
        ></path>
        <path
          fill="url(#paint1_linear_2499_183)"
          d="M48 22.762l-12.124-7.139-21.944 12.29 12.563 7.348L48 22.762z"
        ></path>
        <path
          fill="url(#paint2_linear_2499_183)"
          d="M26.495 35.261L26.536 50 47.96 37.31 48 22.762l-21.505 12.5z"
        ></path>
        <path
          fill="url(#paint3_linear_2499_183)"
          d="M17.604 25.06l.006 2.09c0 .438.288.88.863 1.214 1.156.678 3.04.678 4.202 0 .585-.34.878-.788.878-1.234l-.006-2.09c0 .445-.29.894-.878 1.234-1.163.678-3.046.678-4.203 0-.575-.337-.862-.776-.862-1.215z"
        ></path>
        <path
          fill="url(#paint4_linear_2499_183)"
          d="M24.596 28.698l.006 2.09c0 .44.288.882.863 1.216 1.157.677 3.04.677 4.203 0 .584-.34.878-.79.878-1.235l-.006-2.09c0 .446-.291.894-.879 1.235-1.163.677-3.046.677-4.202 0-.575-.338-.863-.777-.863-1.216z"
        ></path>
        <path
          fill="url(#paint5_linear_2499_183)"
          d="M25.367 20.672l.006 2.09c0 .439.288.881.863 1.215 1.157.678 3.04.678 4.203 0 .584-.34.878-.789.878-1.234l-.006-2.09c0 .445-.291.894-.879 1.234-1.163.678-3.046.678-4.202 0-.575-.337-.863-.776-.863-1.215z"
        ></path>
        <path
          fill="url(#paint6_linear_2499_183)"
          d="M32.36 24.312l.006 2.09c0 .439.288.88.862 1.215 1.157.677 3.04.677 4.203 0 .585-.34.878-.79.878-1.234l-.006-2.09c0 .445-.29.893-.878 1.234-1.163.677-3.046.677-4.203 0-.575-.337-.862-.776-.862-1.215z"
        ></path>
        <path
          fill="url(#paint7_linear_2499_183)"
          d="M32.783 16.842l.006 2.09c0 .439.288.881.863 1.215 1.156.678 3.04.678 4.202 0 .585-.34.879-.789.879-1.234l-.007-2.09c0 .445-.29.894-.878 1.234-1.163.678-3.046.678-4.202 0-.575-.337-.863-.776-.863-1.215z"
        ></path>
        <path
          fill="url(#paint8_linear_2499_183)"
          d="M39.775 20.5l.007 2.09c0 .44.287.881.862 1.215 1.157.678 3.04.678 4.203 0 .584-.34.878-.789.878-1.234l-.006-2.09c0 .445-.29.894-.879 1.234-1.162.678-3.046.678-4.202 0-.575-.337-.863-.776-.863-1.215z"
        ></path>
        <path
          fill="url(#paint9_linear_2499_183)"
          d="M18.482 23.822c-1.163.677-1.172 1.775-.016 2.449 1.157.678 3.04.678 4.203 0 1.162-.678 1.172-1.775.012-2.45-1.156-.677-3.036-.674-4.202 0h.003z"
        ></path>
        <path
          fill="url(#paint10_linear_2499_183)"
          d="M25.475 27.464c-1.163.678-1.173 1.775-.016 2.45 1.156.677 3.04.677 4.202 0 1.163-.678 1.172-1.776.013-2.45-1.157-.678-3.037-.674-4.203 0h.004z"
        ></path>
        <path
          fill="url(#paint11_linear_2499_183)"
          d="M26.246 19.438c-1.163.677-1.173 1.775-.016 2.45 1.156.677 3.04.677 4.202 0 1.163-.678 1.172-1.776.013-2.45-1.157-.678-3.037-.675-4.203 0h.004z"
        ></path>
        <path
          fill="url(#paint12_linear_2499_183)"
          d="M33.238 23.077c-1.163.678-1.172 1.775-.016 2.45 1.157.677 3.04.677 4.203 0 1.162-.678 1.172-1.775.012-2.45-1.156-.677-3.036-.674-4.202 0h.003z"
        ></path>
        <path
          fill="url(#paint13_linear_2499_183)"
          d="M33.661 15.509c-1.162.678-1.172 1.775-.016 2.45 1.157.677 3.04.677 4.203 0 1.163-.678 1.172-1.776.013-2.45-1.157-.678-3.037-.675-4.203 0h.003z"
        ></path>
        <path
          fill="url(#paint14_linear_2499_183)"
          d="M40.654 19.148c-1.163.678-1.173 1.775-.016 2.45 1.156.677 3.04.677 4.202 0 1.163-.678 1.173-1.775.013-2.45-1.157-.677-3.037-.674-4.202 0h.003z"
        ></path>
      </g>
      <g filter="url(#filter0_d_2499_183)">
        <path
          fill="url(#paint15_linear_2499_183)"
          fillRule="evenodd"
          d="M47 32.99c4.401 0 8-3.589 8-8 0-4.41-3.599-7.99-8-7.99s-8 3.59-8 8 3.59 8 8 8v-.01z"
          clipRule="evenodd"
        ></path>
      </g>
      <g clipPath="url(#clip1_2499_183)" opacity="0.8">
        <path
          fill="#fff"
          d="M50.679 24.52l-4.894-2.912a.35.35 0 00-.54.295h-.002v6.047h.002a.35.35 0 00.348.352.403.403 0 00.197-.06l4.889-2.91a.527.527 0 000-.811z"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_2499_183"
          width="26"
          height="26"
          x="33"
          y="11"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dx="-1" dy="-1"></feOffset>
          <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.133333 0 0 0 0 0.160784 0 0 0 0 0.192157 0 0 0 0.31 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2499_183"></feBlend>
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2499_183" result="shape"></feBlend>
        </filter>
        <linearGradient
          id="paint0_linear_2499_183"
          x1="11.5"
          x2="24.646"
          y1="42.999"
          y2="28.751"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.12" stopColor="#A9A9B9"></stop>
          <stop offset="1" stopColor="#DDDDE4"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2499_183"
          x1="31.791"
          x2="31.155"
          y1="33.069"
          y2="15.617"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B4B4C2"></stop>
          <stop offset="0.724" stopColor="#F2F2F2"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_2499_183"
          x1="37.768"
          x2="35.841"
          y1="46.959"
          y2="22.875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D0D0E0"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_2499_183"
          x1="20.723"
          x2="20.584"
          y1="28.445"
          y2="25.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ACACBE"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_2499_183"
          x1="27.715"
          x2="27.576"
          y1="32.084"
          y2="28.679"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ACACBE"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_2499_183"
          x1="28.486"
          x2="28.348"
          y1="24.058"
          y2="20.653"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ACACBE"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_2499_183"
          x1="35.478"
          x2="35.34"
          y1="27.697"
          y2="24.292"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ACACBE"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_2499_183"
          x1="35.902"
          x2="35.763"
          y1="20.227"
          y2="16.823"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ACACBE"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_2499_183"
          x1="42.894"
          x2="42.756"
          y1="23.886"
          y2="20.481"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ACACBE"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_2499_183"
          x1="20.719"
          x2="20.606"
          y1="26.392"
          y2="23.313"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_2499_183"
          x1="27.711"
          x2="27.598"
          y1="30.035"
          y2="26.956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_2499_183"
          x1="28.482"
          x2="28.369"
          y1="22.009"
          y2="18.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_2499_183"
          x1="35.475"
          x2="35.361"
          y1="25.648"
          y2="22.569"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_2499_183"
          x1="35.898"
          x2="35.785"
          y1="18.08"
          y2="15.001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_2499_183"
          x1="42.891"
          x2="42.777"
          y1="21.719"
          y2="18.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F5F5"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient id="paint15_linear_2499_183" x1="39" x2="55" y1="25" y2="25" gradientUnits="userSpaceOnUse">
          <stop stopColor="#DD2476"></stop>
          <stop offset="1" stopColor="#FF512F"></stop>
        </linearGradient>
        <clipPath id="clip0_2499_183">
          <path fill="#fff" d="M0 0H37V35H0z" transform="translate(11 15)"></path>
        </clipPath>
        <clipPath id="clip1_2499_183">
          <path fill="#fff" d="M0 0H9V9H0z" transform="translate(43.75 19.941)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
